// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/euz1eqv.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
video {
  display: inline-block;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

a:focus {
  outline: thin dotted;
}

a:active,
a:hover {
  outline: 0;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

hr {
  box-sizing: content-box;
  height: 0;
}

mark {
  background: #ffe100;
  color: #000;
}

code,
kbd,
pre,
samp {
  font-family: monospace, serif;
  font-size: 1em;
}

pre {
  white-space: pre-wrap;
}

q {
  quotes: "“" "”" "‘" "’";
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 0;
}

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  border: 0;
  padding: 0;
}

button,
input,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  margin: 0;
}

button,
input {
  line-height: normal;
}

button,
select {
  text-transform: none;
}

button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

input[type=checkbox],
input[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

input[type=search] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
}

input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
  vertical-align: top;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

*,
*::after,
*::before {
  box-sizing: border-box;
}

::selection {
  background-color: grey;
  color: white;
}

::-moz-selection {
  background-color: grey;
  color: white;
}

main {
  position: relative;
  width: 100%;
  height: 100vh;
}

#slider {
  width: 100%;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}

#slider canvas {
  width: 150%;
  height: 150%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

#slider img {
  z-index: 6 !important;
}

.slider-inner {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1060px;
  height: 100%;
  margin: 0 auto;
  z-index: 5;
}

#slider-content {
  padding: 0 10px;
}

#slider-content .page-select {
  border: 2px solid;
  padding: 0.2em;
  cursor: pointer;
}
#slider-content .page-select:hover {
  background-color: #ffc917;
  color: black;
}

#slider-content h2 {
  font-family: "Varela Round";
  font-weight: 400;
  font-size: 30px;
  letter-spacing: 5px;
  color: white;
  line-height: 30px;
  margin: 20px 0 60px;
}

@media screen and (min-width: 800px) {
  #slider-content h2 {
    font-size: 110px;
    line-height: 100px;
  }
}
#slider-content span {
  display: none;
}

#slider-content .meta {
  display: inline-block;
  font-family: "Varela Round";
  font-size: 11px;
  letter-spacing: 5px;
  color: #88888a;
  text-transform: uppercase;
  position: relative;
}

@media screen and (min-width: 800px) {
  #slider-content .meta {
    font-size: 13px;
  }
}
#slider-content .meta:after {
  content: "";
  display: block;
  position: absolute;
  top: 5px;
  right: -55px;
  width: 45px;
  height: 2px;
  background-color: #ffc917;
}

#slider-content #slide-status {
  margin-top: 10px;
  font-family: "Varela Round";
  font-weight: 400;
  font-size: 18px;
  color: white;
}

@media screen and (min-width: 800px) {
  #slider-content #slide-status {
    font-size: 34px;
  }
}
#pagination {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 30px;
  z-index: 6;
}

#pagination button {
  display: block;
  appearance: none;
  border: 0;
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 100%;
  padding: 0;
  margin: 30px 0;
  cursor: pointer;
  position: relative;
  opacity: 0.2;
  transition: opacity 0.2s ease-in-out;
  outline: none;
}

#pagination button:hover {
  opacity: 0.5;
}

#pagination button.active {
  opacity: 1;
}

#pagination button.active:before {
  width: 300%;
  height: 300%;
  opacity: 1;
}

#pagination button:before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  opacity: 0;
  transition: opacity 0.4s ease-in-out, width 0.4s ease-in-out, height 0.4s ease-in-out;
}

/* Page Loader */
.loading:before {
  content: "";
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #050505;
}

.loading:after {
  content: "";
  position: fixed;
  z-index: 100;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  margin: -30px 0 0 -30px;
  pointer-events: none;
  border-radius: 50%;
  opacity: 0.4;
  background: white;
  animation: loaderAnim 0.7s linear infinite alternate forwards;
}

@keyframes loaderAnim {
  to {
    opacity: 1;
    transform: scale3d(0.5, 0.5, 1);
  }
}
@keyframes blurry {
  0% {
    filter: blur(100px);
  }
  100% {
    filter: blur(0px);
  }
}
.main {
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
  background-color: #050505;
  filter: blur(100px);
  position: relative;
  animation: blurry 2s ease-in-out forwards;
}

.overlay-main {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 5%;
  height: 100vh !important;
  opacity: 1;
  background-image: linear-gradient(to top, #000000, #220a0f, #3a0b15, #540616, #6d0012, #841511, #9a290c, #af3e00, #c76000, #dd8200, #f0a500, #ffc917);
  z-index: 5;
}

img {
  width: 100%;
  height: 100%;
  object-position: center center;
  object-fit: cover;
  image-rendering: auto;
  z-index: 6;
}

/* GLITCH BUTTON */
button, button::after {
  padding: 0.8em 0.5em;
  font-size: 20px;
  border: none;
  border-radius: 5px;
  color: white;
  background-color: transparent;
  position: absolute;
  bottom: 26%;
  border: 3px solid #ffc917;
}

button::after {
  --move1: inset(50% 50% 50% 50%);
  --move2: inset(31% 0 40% 0);
  --move3: inset(39% 0 15% 0);
  --move4: inset(45% 0 40% 0);
  --move5: inset(45% 0 6% 0);
  --move6: inset(14% 0 61% 0);
  clip-path: var(--move1);
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
}

button:hover::after {
  animation: glitch_4011 1s;
  text-shadow: 10 10px 10px black;
  animation-timing-function: steps(2, end);
  text-shadow: -3px -3px 0px #050505, 3px 3px 0px #050505;
  background-color: transparent;
  border: 3px solid #ffc917;
}

button:hover {
  text-shadow: -1px -1px 0px #f00000, 1px 1px 0px #f00000;
}

button:hover {
  background-color: transparent;
  border: 1px solid #f00000;
  box-shadow: 0px 10px 10px -10px #f00000;
}

@keyframes glitch_4011 {
  0% {
    clip-path: var(--move1);
    transform: translate(0px, -10px);
  }
  10% {
    clip-path: var(--move2);
    transform: translate(-10px, 10px);
  }
  20% {
    clip-path: var(--move3);
    transform: translate(10px, 0px);
  }
  30% {
    clip-path: var(--move4);
    transform: translate(-10px, 10px);
  }
  40% {
    clip-path: var(--move5);
    transform: translate(10px, -10px);
  }
  50% {
    clip-path: var(--move6);
    transform: translate(-10px, 10px);
  }
  60% {
    clip-path: var(--move1);
    transform: translate(10px, -10px);
  }
  70% {
    clip-path: var(--move3);
    transform: translate(-10px, 10px);
  }
  80% {
    clip-path: var(--move2);
    transform: translate(10px, -10px);
  }
  90% {
    clip-path: var(--move4);
    transform: translate(-10px, 10px);
  }
  100% {
    clip-path: var(--move1);
    transform: translate(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Main/Styles.scss","webpack://./src/assets/scss/components/_colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;;;;;;;;;;;;EAYE,cAAA;AACF;;AAEA;;;EAGE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;;EAEE,UAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;;EAEE,iBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EAEE,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,mBC9DgB;ED+DhB,WAAA;AACF;;AAEA;;;;EAIE,6BAAA;EACA,cAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;AACF;;AAEA;;;;EAIE,oBAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;;EAEE,oBAAA;AACF;;AAEA;;;;EAIE,0BAAA;EACA,eAAA;AACF;;AAEA;;EAEE,eAAA;AACF;;AAEA;;EAEE,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,6BAAA;EAGA,uBAAA;AACF;;AAEA;;EAEE,wBAAA;AACF;;AAEA;;EAEE,SAAA;EACA,UAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,iBAAA;AACF;;AAEA;;;EAGE,sBAAA;AACF;;AAEA;EACE,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,sBAAA;EACA,YAAA;AACF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AADF;;AAIA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AADF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AAAF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAGA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAAF;AAGE;EACE,yBCjQO;EDkQP,YAAA;AADJ;;AAIA;EACE,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AADF;;AAGA;EACE;IACE,gBAAA;IACA,kBAAA;EAAF;AACF;AAEA;EACE,aAAA;AAAF;;AAEA;EACE,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,cCxRS;EDyRT,yBAAA;EACA,kBAAA;AACF;;AACA;EACE;IACE,eAAA;EAEF;AACF;AAAA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,yBC7SS;AD+SX;;AAAA;EACE,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAGF;;AADA;EACE;IACE,eAAA;EAIF;AACF;AADA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;AAGF;;AADA;EACE,cAAA;EAGA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;AAIF;;AAFA;EACE,YAAA;AAKF;;AAHA;EACE,UAAA;AAMF;;AAJA;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAOF;;AALA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,UAAA;EACA,qFAAA;AAQF;;AAJA,gBAAA;AACA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAOF;;AALA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,6DAAA;AAQF;;AALA;EACE;IACE,UAAA;IACA,+BAAA;EAQF;AACF;AALA;EACI;IACI,mBAAA;EAON;EAJE;IACI,iBAAA;EAMN;AACF;AAHA;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBC7ZU;ED8ZV,mBAAA;EACA,kBAAA;EACA,yCAAA;AAKF;;AAFA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,SAAA;EACA,wBAAA;EACA,UAAA;EAEA,qJAAA;EAeA,UAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;AAVF;;AAgBA,kBAAA;AAGA;EACE,oBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAfF;;AAkBA;EACE,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,+BAAA;EACA,wCAAA;EACA,uDAAA;EACA,6BAAA;EACA,yBAAA;AAfF;;AAkBA;EACE,uDAAA;AAfF;;AAkBA;EACE,6BAAA;EACA,yBAAA;EACA,uCAAA;AAfF;;AAkBA;EACE;IACE,uBAAA;IACA,gCAAA;EAfF;EAkBA;IACE,uBAAA;IACA,iCAAA;EAhBF;EAmBA;IACE,uBAAA;IACA,+BAAA;EAjBF;EAoBA;IACE,uBAAA;IACA,iCAAA;EAlBF;EAqBA;IACE,uBAAA;IACA,iCAAA;EAnBF;EAsBA;IACE,uBAAA;IACA,iCAAA;EApBF;EAuBA;IACE,uBAAA;IACA,iCAAA;EArBF;EAwBA;IACE,uBAAA;IACA,iCAAA;EAtBF;EAyBA;IACE,uBAAA;IACA,iCAAA;EAvBF;EA0BA;IACE,uBAAA;IACA,iCAAA;EAxBF;EA2BA;IACE,uBAAA;IACA,uBAAA;EAzBF;AACF","sourcesContent":["@import \"../../assets/scss/combined.scss\";\n@import url(\"https://use.typekit.net/euz1eqv.css\");\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n}\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\na:focus {\n  outline: thin dotted;\n}\n\na:active,\na:hover {\n  outline: 0;\n}\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n\nb,\nstrong {\n  font-weight: bold;\n}\n\ndfn {\n  font-style: italic;\n}\n\nhr {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  height: 0;\n}\n\nmark {\n  background: $bdt-yellow-gold;\n  color: #000;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, serif;\n  font-size: 1em;\n}\n\npre {\n  white-space: pre-wrap;\n}\n\nq {\n  quotes: \"“\" \"”\" \"‘\" \"’\";\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nimg {\n  border: 0;\n}\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\nfigure {\n  margin: 0;\n}\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\nlegend {\n  border: 0;\n  padding: 0;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: 100%;\n  margin: 0;\n}\n\nbutton,\ninput {\n  line-height: normal;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n*,\n*::after,\n*::before {\n  box-sizing: border-box;\n}\n\n::selection {\n  background-color: grey;\n  color: white;\n}\n\n::-moz-selection {\n  background-color: grey;\n  color: white;\n}\n\n\n\nmain {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n}\n\n#slider {\n  width: 100%;\n  max-width: 1200px;\n  height: 100%;\n  margin: 0 auto;\n  position: relative;\n}\n#slider canvas {\n  width: 150%;\n  height: 150%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n}\n#slider img {\n  z-index: 6 !important;\n}\n\n.slider-inner {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 1060px;\n  height: 100%;\n  margin: 0 auto;\n  z-index: 5;\n}\n\n#slider-content {\n  padding: 0 10px;\n\n}\n\n#slider-content .page-select {\n  border: 2px solid;\n  padding: 0.2em;\n  cursor: pointer;\n  \n\n  &:hover {\n    background-color: $bdt-gold;\n    color: black;\n  }\n}\n#slider-content h2 {\n  font-family: \"Varela Round\";\n  font-weight: 400;\n  font-size: 30px;\n  letter-spacing: 5px;\n  color: white;\n  line-height: 30px;\n  margin: 20px 0 60px;\n}\n@media screen and (min-width: 800px) {\n  #slider-content h2 {\n    font-size: 110px;\n    line-height: 100px;\n  }\n}\n#slider-content span {\n  display: none;\n}\n#slider-content .meta {\n  display: inline-block;\n  font-family: \"Varela Round\";\n  font-size: 11px;\n  letter-spacing: 5px;\n  color: $bdt-gray;\n  text-transform: uppercase;\n  position: relative;\n}\n@media screen and (min-width: 800px) {\n  #slider-content .meta {\n    font-size: 13px;\n  }\n}\n#slider-content .meta:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 5px;\n  right: -55px;\n  width: 45px;\n  height: 2px;\n  background-color: $bdt-gold;\n}\n#slider-content #slide-status {\n  margin-top: 10px;\n  font-family: \"Varela Round\";\n  font-weight: 400;\n  font-size: 18px;\n  color: white;\n}\n@media screen and (min-width: 800px) {\n  #slider-content #slide-status {\n    font-size: 34px;\n  }\n}\n\n#pagination {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 30px;\n  z-index: 6;\n}\n#pagination button {\n  display: block;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  width: 16px;\n  height: 16px;\n  background-color: #ffffff;\n  border-radius: 100%;\n  padding: 0;\n  margin: 30px 0;\n  cursor: pointer;\n  position: relative;\n  opacity: 0.2;\n  transition: opacity 0.2s ease-in-out;\n  outline: none;\n}\n#pagination button:hover {\n  opacity: 0.5;\n}\n#pagination button.active {\n  opacity: 1;\n}\n#pagination button.active:before {\n  width: 300%;\n  height: 300%;\n  opacity: 1;\n}\n#pagination button:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  opacity: 0;\n  transition: opacity 0.4s ease-in-out, width 0.4s ease-in-out,\n    height 0.4s ease-in-out;\n}\n\n/* Page Loader */\n.loading:before {\n  content: \"\";\n  position: fixed;\n  z-index: 100;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #050505;\n}\n.loading:after {\n  content: \"\";\n  position: fixed;\n  z-index: 100;\n  top: 50%;\n  left: 50%;\n  width: 60px;\n  height: 60px;\n  margin: -30px 0 0 -30px;\n  pointer-events: none;\n  border-radius: 50%;\n  opacity: 0.4;\n  background: white;\n  animation: loaderAnim 0.7s linear infinite alternate forwards;\n}\n\n@keyframes loaderAnim {\n  to {\n    opacity: 1;\n    transform: scale3d(0.5, 0.5, 1);\n  }\n}\n\n@keyframes blurry {\n    0% {\n        filter: blur(100px);\n    }\n\n    100% {\n        filter: blur(0px);\n    }\n}\n\n.main {\n  overflow: hidden;\n  margin: 0 !important;\n  padding: 0 !important;\n  background-color: $bdt-black;\n  filter: blur(100px);\n  position: relative;\n  animation: blurry 2s ease-in-out forwards;\n}\n\n.overlay-main {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 5%;\n  height: 100vh !important;\n  opacity: 1;\n\n  background-image: linear-gradient(\n    to top,\n    #000000,\n    #220a0f,\n    #3a0b15,\n    #540616,\n    #6d0012,\n    #841511,\n    #9a290c,\n    #af3e00,\n    #c76000,\n    #dd8200,\n    #f0a500,\n    #ffc917\n  );\n  z-index: 5;\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n  object-position: center center;\n  object-fit: cover;\n  image-rendering: auto;\n  z-index: 6;\n}\n\n\n\n\n/* GLITCH BUTTON */\n\n\nbutton,button::after {\n  padding: .8em .5em;\n  font-size: 20px;\n  border: none;\n  border-radius: 5px;\n  color: white;\n  background-color: transparent;\n  position: absolute;\n  bottom: 26%;\n  border: 3px solid $bdt-gold;\n}\n\nbutton::after {\n  --move1: inset(50% 50% 50% 50%);\n  --move2: inset(31% 0 40% 0);\n  --move3: inset(39% 0 15% 0);\n  --move4: inset(45% 0 40% 0);\n  --move5: inset(45% 0 6% 0);\n  --move6: inset(14% 0 61% 0);\n  clip-path: var(--move1);\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: block;\n}\n\nbutton:hover::after {\n  animation: glitch_4011 1s;\n  text-shadow: 10 10px 10px black;\n  animation-timing-function: steps(2, end);\n  text-shadow: -3px -3px 0px $bdt-black, 3px 3px 0px $bdt-black;\n  background-color: transparent;\n  border: 3px solid $bdt-gold;\n}\n\nbutton:hover {\n  text-shadow: -1px -1px 0px $bdt-red, 1px 1px 0px $bdt-red;\n}\n\nbutton:hover {\n  background-color: transparent;\n  border: 1px solid $bdt-red;\n  box-shadow: 0px 10px 10px -10px $bdt-red;\n}\n\n@keyframes glitch_4011 {\n  0% {\n    clip-path: var(--move1);\n    transform: translate(0px,-10px);\n  }\n\n  10% {\n    clip-path: var(--move2);\n    transform: translate(-10px,10px);\n  }\n\n  20% {\n    clip-path: var(--move3);\n    transform: translate(10px,0px);\n  }\n\n  30% {\n    clip-path: var(--move4);\n    transform: translate(-10px,10px);\n  }\n\n  40% {\n    clip-path: var(--move5);\n    transform: translate(10px,-10px);\n  }\n\n  50% {\n    clip-path: var(--move6);\n    transform: translate(-10px,10px);\n  }\n\n  60% {\n    clip-path: var(--move1);\n    transform: translate(10px,-10px);\n  }\n\n  70% {\n    clip-path: var(--move3);\n    transform: translate(-10px,10px);\n  }\n\n  80% {\n    clip-path: var(--move2);\n    transform: translate(10px,-10px);\n  }\n\n  90% {\n    clip-path: var(--move4);\n    transform: translate(-10px,10px);\n  }\n\n  100% {\n    clip-path: var(--move1);\n    transform: translate(0);\n  }\n}\n\n","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
